import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { App } from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router } from "react-router-dom";

/**
 * For old version of iPad
 */
// import 'core-js/fn/number/is-nan';
// import 'core-js/fn';
import 'core-js/es';
// import 'raf/polyfill';
// Polyfill Array.flat()
import flat from 'core-js/features/array/flat';

// Polyfill required for MUIDataTable to work in Safari
import 'intl-collator';

ReactDOM.render(
    <Router>
        <App />
    </Router>,
    document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.register();
serviceWorker.unregister();
